import type { StyleLayer } from './utils/types'

export const layers_parkingTilda_street_completeness: StyleLayer[] = [
  {
    id: 'complete_no',
    type: 'line',
    filter: ['match', ['get', 'parking'], ['no', 'separate'], true, false],
    paint: {
      'line-color': '#ff8500',
      'line-opacity': ['match', ['get', 'highway'], ['construction'], 0.25, 1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 15, 1, 20, 8],
    },
  },
  {
    id: 'complete_data_missing',
    type: 'line',
    filter: ['match', ['get', 'parking'], ['missing'], true, false],
    paint: {
      'line-opacity': ['match', ['get', 'highway'], ['construction'], 0.25, 1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 15, 2, 20, 16],
    },
  },
  {
    id: 'complete_too_small',
    type: 'line',
    filter: ['match', ['get', 'reason'], ['capacity_below_zero'], true, false],
    paint: {
      'line-color': '#b0b0b0',
      'line-opacity': ['match', ['get', 'highway'], ['construction'], 0.25, 1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 15, 1, 20, 8],
    },
  },
]
